import { render } from "./CText.vue?vue&type=template&id=2b345885"
import script from "./CText.vue?vue&type=script&lang=js"
export * from "./CText.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__